(function () {
    document.addEventListener('click', (e) => {
        const a = e.target.closest('.rail-item');
        if (!a || !a.closest('.nav-rail')) return;
        a.parentElement.querySelectorAll('.rail-item').forEach(x => x.classList.toggle('is-active', x === a));
    });
})();
